import { ORDservice } from "@/core/services/identification/organizationRootDetails.service";

export const isWarehouseCheckinDisabled = () => {
  return ORDservice.isWarehouseCheckinDisabled();
};
